import React, { Fragment, useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { Button } from "bootstrap";

const ManageAdList = () =>{
    const { pubId, } = useParams(); // Get publisher ID from URL
    const navigate = useNavigate();
    const [adList, setAdList] = useState("");
    const [loading, setLoading] = useState(true);
    const [message, setMessage] = useState("");
    const alladList = async () =>{
      try {
            const token = localStorage.getItem("token");
            const allAdsListRes = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/pub/getAllAdPlacements/${pubId}`, {
                    headers : {
                        Authorization: `Bearer ${token}`,
                        // "Content-Type": "application/json",
                        Accept: "application/json",
                    },
                }
              );
                console.log(allAdsListRes);
                if(allAdsListRes.status === 200){
                  setAdList(allAdsListRes?.data?.data);
                }else {
                  setMessage("No domains found.");
                }
        } catch (error) {
          if (error.status === 401) {
            console.error("Unauthorized! Token might be expired.");
            localStorage.removeItem("token");
            navigate("/admin");
          } else {
            console.error("Error fetching data:", error);
          }
          setMessage("Error fetching Data.");
        } finally {
            setLoading(false);
          }
        
    } 
    // const pubIDStatus = adList.pid
    // console.log(pubIDStatus);
    
    // const toggleStatus = async (pubIdStatus, AccountId) => {
    //     try {
    //         const token = localStorage.getItem("token");
    //         const adStatusRes = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/pub/updateAdStatus/${AccountId}/${pubIdStatus}?status=1`, {
    //             headers : {
    //                 Authorization: `Bearer ${token}`,
    //                 Accept: "application/json",
    //             },
    //         }
    //       );
    //       console.log(adStatusRes);
    //     } catch (error) {
    //         if (error.status === 401) {
    //             console.error("Unauthorized! Token might be expired.");
    //             localStorage.removeItem("token");
    //             navigate("/admin");
    //           } else {
    //             console.error("Error fetching data:", error);
    //           }            
    //     }
    // }

    const toggleStatus = async (pubIdStatus, accountId) => {
        try {
          const token = localStorage.getItem("token");
      
          // Find the ad placement to get current status
          const targetAd = adList.find(ad => ad.pid === pubIdStatus);
          const currentStatus = targetAd?.status ?? 1;
          const newStatus = currentStatus === 0 ? 1 : 0;
      
          const adStatusRes = await axios.get(
            `${process.env.REACT_APP_API_BASE_URL}/api/pub/updateAdStatus/${accountId}/${pubIdStatus}?status=${newStatus}`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
                Accept: "application/json",
              },
            }
          );
      
          if (adStatusRes.status === 200) {
            // ✅ Update the local state without reload
            setAdList(prevList =>
              prevList.map(ad =>
                ad.pid === pubIdStatus ? { ...ad, status: newStatus } : ad
              )
            );
          }
        } catch (error) {
          if (error.status === 401) {
            console.error("Unauthorized! Token might be expired.");
            localStorage.removeItem("token");
            navigate("/admin");
          } else {
            console.error("Error updating ad status:", error);
          }
        }
      };
      
    useEffect(() => {
        alladList();
  }, [pubId]);

  return (
    <section className="mainContainer">
      <div className="container mt-4">
        {/* <h2>Manage Ad</h2> */}
        {message && <div className="alert alert-info">{message}</div>}
      <table className="table table-striped table-hover table-bordered">
                <thead>
            <tr>
              <th scope="col">S.N </th>
              <th scope="col">Display Name</th>
              <th scope="col">Domain</th>
              <th scope="col">Ad Status</th>
              <th scope="col"></th>
            </tr>
          </thead>
          <tbody>
            {
              adList?.length > 0 ? (
                adList.map((adlists, adListsInd) =>(
                  <tr key={adListsInd}>
                    <td>{adListsInd + 1}</td>
                    <td>{adlists.ad_display_name}</td>
                    <td>{adlists.domain}</td>
                    {/* <td>{adlists.ad_display_name}</td> */}
                    <td>
                    <p
                      className=""
                      >
                      {adlists.status === 0 ? "Active" : "Inactive"}
                    </p>
                    </td>
                    <td>
                        {/* <button
                      className="btn btn-warning btn-sm" onClick={() => toggleStatus(adlists.pid, adlists.account_id)}
                      >
                      Enable
                    </button> */}
                    <button
                        className="btn btn-warning btn-sm"
                        onClick={() => toggleStatus(adlists.pid, adlists.account_id)}
                        >
                        {adlists.status === 0 ? "Disable" : "Enable"}
                    </button>
                    </td>
                  </tr>
                ))
              ) : 
              <tr>
                <td colSpan="12" className="text-center">No data available</td>
              </tr>
            }
          </tbody>
      </table>
      </div>
    </section>
  )
}

export default ManageAdList;